import SaveButton from "../../../components/SaveButton";
import TextInput from "../../../components/TextInput";
import { validateMassUpload } from "../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";
import { useState, useEffect } from "react";
import SelectInput from "../../../components/SelectInput";
import CustomLoader from "../../../components/CustomLoader";
import MultiSelectInput from "../../../components/MultiSelectInput";
import CancelButton from "../../../components/CancelButton";
import { useStates } from "../hooks/useStates";
import { toast } from "../../../components/toastNotification";
import { useGetProducerCodeListByCarrierId } from "./hooks/useGetProdCodeByCarrierId";
import { useFranchiseEmployee } from "../Employees/Franchise/hooks/UseFranchiseEmployee";

export const MassUploadExpandedRowShow = ({
  data,
  isEdit = false,
  updateRow,
  setShowEdit,
  setOrigData,
  setAllData,
  origData,
  Cancel,
  setValidData,
  setInvalidData,
  setShow,
  loboptions,
  setDisplayNote,
  selectedTab,
  handleSelectedTab,
  distChannelOpts,
  carriers,
  mgaList,
  carrierProgramOptions,
  carrierLoading,
  employeeOptions,
  codeLevelOptions,
  prodTypesOptions,
  isFranchise,
}) => {
  const associatedOptions = [
    { label: "Office", value: "Office" },
    { label: "Producer", value: "Producer" },
  ];
  const [formData, setFormData] = useState(data);
  const [updatedRowDetails, setUpdatedRowDetails] = useState([]);
  const [selectedIssuedTo, setSelectedIssuedTo] = useState([]);
  const [selectedCrossSale, setSelectedCrossSale] = useState([]);
  const [defaultProducer, setDefaultProducer] = useState("");
  const [carrierProg, setCarrierProg] = useState([]);
  const { data: allProducerCodeListByCarrier } =
    useGetProducerCodeListByCarrierId(formData?.masterCarrierID);
  const employeeOpts =
    employeeOptions &&
    employeeOptions
      ?.filter((x) => x.status !== "Terminated")
      .map((res) => ({
        label: res.employeeId + " - " + res.fullname,
        value: res.employeeId,
        fullname:
          res.firstname +
          (res.middlename ? " " + res.middlename + " " : " ") +
          res.lastname,
        isFranchise: res.employeeTypeName === "Franchise" ? true : false,
      }));
  const masterCodeOpts =
    allProducerCodeListByCarrier &&
    allProducerCodeListByCarrier
      ?.filter((x) => x.officeName !== "")
      ?.map((x) => ({
        label: x.producerCodes + " - " + x.officeName,
        value: x.carrierProducerCodeId,
      }));
  const rollUpCodeOpts =
    allProducerCodeListByCarrier &&
    allProducerCodeListByCarrier.map((x) => ({
      label: x.producerCodes + " - " + x.officeName,
      value: x.carrierProducerCodeId,
    }));

  const rollUpCodeActiveOpts =
    allProducerCodeListByCarrier &&
    allProducerCodeListByCarrier
      .filter((x) => x.officeName !== "")
      .map((x) => ({
        label: x.officeName,
        value: x.carrierProducerCodeId,
      }));

  const { data: franchiseEmp } = useFranchiseEmployee();

  const franchiseEmpOpts = franchiseEmp
    ?.filter((a) => a.isActive === "true")
    ?.map((x) => {
      return {
        label: x.firstName + " " + x.lastName,
        value: x.franchiseEmployeeId,
        managerEmployeeId: x.franchiseEmployeeId,
      };
    });

  const codeStatus = [
    { label: "Active", value: true },
    {
      label: "Inactive",
      value: false,
    },
  ];
  const { data: states } = useStates();
  const allStatesOpt = states?.map((x) => {
    return {
      label: x.state,
      value: x.state,
    };
  });

  const associatedToVal = formData.associatedTo === "Office" ? true : false;
  const handleChange = (event, field, rollUpId) => {
    if (field === "LOB") {
      setFormData({
        ...formData,
        lineOfBusiness: event === null ? "" : event.label,
      });
    } else if (field === "distributionChannel") {
      if (
        (formData.distributionChannel.toUpperCase() !== "FRANCHISE" &&
          event.label.toUpperCase() === "FRANCHISE") ||
        (formData.distributionChannel.toUpperCase() === "FRANCHISE" &&
          event.label.toUpperCase() !== "FRANCHISE")
      ) {
        setDefaultProducer("");
        setFormData({
          ...formData,
          issuedToList: [],
          producer: [],
        });

        setSelectedIssuedTo([]);
      }
      setFormData({
        ...formData,
        distributionChannel: event === null ? "" : event.label,
      });
    } else if (field === "carrierName") {
      setCarrierProg([]);
      setFormData({
        ...formData,
        carrierName: event === null ? "" : event.label,
        masterCarrierID: event === null ? 0 : event.value,
        rollUpCode: "",
        rollUpId: 0,
        masterCode: "",
        masterCodeStatus: "Active",
        rollUpCodeStatus: "Active",
      });
    } else if (field === "program") {
      setFormData({
        ...formData,
        program: event === null ? "" : event.label,
      });
    } else if (field === "mga") {
      setFormData({
        ...formData,
        mga: event === null ? "" : event.label,
      });
    } else if (field === "associatedTo") {
      if (event.label === "Office") {
        setFormData({
          ...formData,
          associatedTo: event === null ? "" : event.label,
          producer: null,
        });
        setDefaultProducer("");
      } else {
        setFormData({
          ...formData,
          associatedTo: event === null ? "" : event.label,
          storeNumber: "",
          officeCode: "",
        });
      }
    } else if (field === "producer") {
      setFormData({
        ...formData,
        producer: event,
        storeNumber: "",
        officeCode: "",
      });
    } else if (field === "producerCodeType") {
      setFormData({
        ...formData,
        producerCodeTypeId: event === null ? 0 : event.value,
        producerCodeType: event === null ? "" : event.label,
      });
    } else if (field === "codeLevel") {
      setFormData({
        ...formData,
        codeLevel: event === null ? "" : event.label,
      });
    } else if (field === "masterCodeStatus") {
      setFormData({
        ...formData,
        masterCodeStatus: event === true ? "Active" : "Inactive",
      });
    } else if (field === "issuedTo") {
      var empList = [];
      event.map((x) => {
        empList.push(x.value);
      });
      setFormData({
        ...formData,
        issuedToList: event === null ? [] : empList,
      });

      setSelectedIssuedTo(event);
    } else if (field === "rollUpCodeStatus") {
      setFormData({
        ...formData,
        rollUpCodeStatus: event === true ? "Active" : "Inactive",
      });
    } else if (field === "crossSale") {
      var empList = [];
      event.map((x) => {
        empList.push(x.value);
      });
      setFormData({
        ...formData,
        crossSaleList: event === null ? [] : empList,
      });

      setSelectedCrossSale(event);
    } else if (field === "rollUpId") {
      setFormData({
        ...formData,
        rollUpCode: event === null ? "" : event.label,
        rollUpId: rollUpId === null ? 0 : rollUpId,
      });
    } else if (field === "masterCode") {
      setFormData({
        ...formData,
        masterCode: event === null ? "" : event.label,
      });
    } else {
      setFormData({ ...formData, [event.target.name]: event.target.value });
    }
  };
  const handleSubmit = () => {
    updateRow(formData);
    if (
      formData.producerCode &&
      (formData.associatedTo === "Office"
        ? formData.officeCode && formData.storeNumber
        : formData.producer) &&
      formData.lineOfBusiness &&
      formData.carrierName &&
      formData.codeLevel &&
      formData.producerCodeType
    ) {
      updatedRowDetails.push({
        ...formData,
        id: formData.id,
        carrierName: formData.carrierName,
        address: formData.address ? formData.address : "",
        city: formData.city ? formData.city : "",
        state: formData.state ? formData.state : "",
        producerCode: formData.producerCode,
        producerSubCode: formData.producerSubCodes
          ? formData.producerSubCodes
          : "",
        lineOfBusiness: formData.lineOfBusiness,
        storeNumber: formData.storeNumber,
        officeCode:
          formData.associatedTo === "Producer"
            ? ""
            : formData.officeCode
            ? formData.officeCode
            : "",
        producer:
          defaultProducer.length > 0
            ? defaultProducer[0]?.value
            : formData.producer.value
            ? formData.producer.value
            : defaultProducer
            ? defaultProducer.value
            : null,
        mAproducerCodes:
          formData.mAproducerCodes === null
            ? ""
            : String(formData.mAproducerCodes),
        programName: carrierProg
          ? carrierProg.label
          : formData.program
          ? formData.program
          : "",
        dma: formData.dma ? formData.dma : "",
        distributionChannel: formData.distributionChannel
          ? formData.distributionChannel
          : "",
      });

      revalidateProdCode();
    } else {
      toast.fire(
        "Saving Failed",
        "All required fields must be filled!",
        "error"
      );
    }
  };
  const revalidateProdCode = () => {
    validateMassUpload(updatedRowDetails).then((res) => {
      const id = updatedRowDetails.map((d) => d.id);
      const newData = origData.filter((d) => !id.includes(d.id));
      res.map((prodCode) => {
        newData.push(prodCode);
      });
      setOrigData(newData);
      setAllData(newData);
      if (selectedTab === "Invalid" || selectedTab === "Valid") {
        handleSelectedTab(selectedTab, newData);
      }
      var tempValidData = [];
      var tempInvalidData = [];
      newData.map((prodCode) => {
        if (prodCode.isValid) tempValidData.push(prodCode);
        else tempInvalidData.push(prodCode);
      });
      setValidData(tempValidData);
      setInvalidData(tempInvalidData);
    });
    setShow(false);
    setShowEdit(false);
    setDisplayNote(true);
  };
  useEffect(() => {
    setDefaultProducer(
      formData.distributionChannel === "Franchise"
        ? employeeOpts?.filter((x) => x.value.toString() === formData.producer)
        : employeeOpts?.filter((x) => x.value.toString() === formData.producer)
    );
    //setFormData({ ...data, producer: defaultProducer });
    setCarrierProg(
      carrierProgramOptions.filter((x) => x.label === formData.program)
    );
    if (formData.distributionChannel === "Franchise") {
      for (let i = 0; i < formData.issuedToList?.length; i++) {
        employeeOpts
          ?.filter(
            (x) =>
              // x.status !== "Terminated" &&
              x.value.toString() === formData.issuedToList[i]
          )
          .map((x) =>
            selectedIssuedTo.push({
              label: x.label,
              value: x.value,
            })
          );
      }
    } else {
      for (let i = 0; i < formData.issuedToList?.length; i++) {
        employeeOpts
          ?.filter(
            (x) =>
              // x.status !== "Terminated" &&
              x.value.toString() === formData.issuedToList[i]
          )
          .map((x) => {
            selectedIssuedTo.push({
              label: x.label,
              value: x.value,
            });
          });
      }
    }

    for (let i = 0; i < formData.crossSaleList?.length; i++) {
      allStatesOpt
        ?.filter(
          (x) =>
            // x.status !== "Terminated" &&
            x.label === formData.crossSaleList[i]
        )
        .map((x) =>
          selectedCrossSale.push({
            label: x.label,
            value: x.value,
          })
        );
    }
  }, []);
  return (
    <div>
      {carrierProgramOptions && mgaList && !carrierLoading ? (
        <div className="w-full">
          <div className="p-2 space-y-4 border-l-2 border-quinary  rounder-r-none box-shadow mb-2">
            <div className="m-2 bg-white box-shadow rounded-lg h-full p-1 text-xs pb-1">
              {isEdit && (
                <div className="flex flex-row  justify-between items-center pb-1 mt-3 mx-3">
                  <div className="text-sm text-primary font-bold">
                    Edit Producer Code Mass Upload
                  </div>
                  <div className="flex justify-between gap-2">
                    <SaveButton onClick={handleSubmit} />
                    <CancelButton onClick={Cancel} />
                  </div>
                </div>
              )}
              <div className="grid grid-cols-3 gap-y-1 m-2">
                <div className="grid grid-cols-2">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Carrier: <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2 ">
                      Carrier:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput
                      defaultValue={carriers?.filter(
                        (x) =>
                          x.label?.toUpperCase() ===
                          formData.carrierName?.toUpperCase()
                      )}
                      className="expandedLabel"
                      //defaultValue={lob}
                      name="carrierName"
                      options={carriers}
                      onChange={(e) => {
                        handleChange(e ? e : null, "carrierName");
                      }}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.carrierName}
                    </div>
                  )}
                </div>
                <div className=""></div>
                <div className=""></div>
              </div>
              <div className="border-b border-gray-200"></div>
              <div className="grid grid-cols-3 gap-y-1 m-2">
                <div className="grid grid-cols-2 ">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Distribution Channel:
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Distribution Channel:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput
                      defaultValue={distChannelOpts.filter(
                        (x) => x.label === formData.distributionChannel
                      )}
                      className="expandedLabel"
                      //defaultValue={lob}
                      name="distributionChannel"
                      options={distChannelOpts}
                      onChange={(e) =>
                        handleChange(e ? e : null, "distributionChannel")
                      }
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.distributionChannel}
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-2">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Associated To: <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2 ">
                      Associated To:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput
                      defaultValue={associatedOptions.filter(
                        (x) => x.label === formData.associatedTo
                      )}
                      className="expandedLabel"
                      isClearable={false}
                      name="associatedTo"
                      options={associatedOptions}
                      onChange={(e) => {
                        handleChange(e ? e : null, "associatedTo");
                      }}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.associatedTo}
                    </div>
                  )}
                </div>
                {formData.associatedTo === "Office" && (
                  <div className="grid grid-cols-2 ">
                    {isEdit ? (
                      <div className="expandedLabel text-right mr-2 mt-1">
                        Office Code:{" "}
                        {formData.associatedTo !== "Office" ? (
                          <></>
                        ) : (
                          <span className="text-xs text-red-500">* </span>
                        )}
                      </div>
                    ) : (
                      <div className="expandedLabel text-right mr-2">
                        Office Code:
                      </div>
                    )}
                    {isEdit ? (
                      <TextInput
                        disabled={!associatedToVal}
                        type="text"
                        name="officeCode"
                        value={formData.officeCode}
                        className="expandedLabel"
                        onChange={(e) => handleChange(e)}
                      />
                    ) : (
                      <div className="font-medium lg:text-left">
                        {" "}
                        {formData.officeCode}
                      </div>
                    )}
                  </div>
                )}
                {formData.associatedTo === "Office" && (
                  <div className="grid grid-cols-2 ">
                    {isEdit ? (
                      <div className="expandedLabel text-right mr-2 mt-1">
                        Store Number:{" "}
                        {formData.associatedTo !== "Office" ? (
                          <></>
                        ) : (
                          <span className=" text-xs text-red-500">* </span>
                        )}
                      </div>
                    ) : (
                      <div className="expandedLabel text-right mr-2">
                        Store Number:
                      </div>
                    )}
                    {isEdit ? (
                      <TextInput
                        disabled={!associatedToVal}
                        value={formData.storeNumber}
                        className="expandedLabel"
                        name="storeNumber"
                        onChange={(e) => {
                          const re = /^[0-9\b]+$/;

                          // if value is not blank, then test the regex

                          if (
                            e.target.value === "" ||
                            re.test(e.target.value)
                          ) {
                            handleChange(e);
                          }
                        }}
                      />
                    ) : (
                      <div className="font-medium lg:text-left">
                        {formData.storeNumber}
                      </div>
                    )}
                  </div>
                )}
                {formData.associatedTo === "Producer" && (
                  <div className="grid grid-cols-2 ">
                    {isEdit ? (
                      <div className="expandedLabel text-right mr-2 mt-1">
                        Producer:{" "}
                        {formData.associatedTo !== "Producer" ? (
                          <></>
                        ) : (
                          <span className=" text-xs text-red-500">* </span>
                        )}
                      </div>
                    ) : (
                      <div className="expandedLabel text-right mr-2">
                        Producer:
                      </div>
                    )}
                    {isEdit ? (
                      <SelectInput
                        value={defaultProducer}
                        isDisabled={associatedToVal}
                        className="expandedLabel"
                        name="producer"
                        options={
                          formData.distributionChannel === "Franchise"
                            ? employeeOpts
                                ?.filter(
                                  (x) =>
                                    x.employeeId !== null &&
                                    x.employeeId !== "" &&
                                    x.isFranchise === true
                                )
                                .map((x) => {
                                  return {
                                    label: x.value + " - " + x.fullname,
                                    value: x.value,
                                  };
                                })
                            : employeeOpts
                                ?.filter(
                                  (x) =>
                                    x.employeeId !== null &&
                                    x.employeeId !== "" &&
                                    x.isFranchise === false
                                )
                                .map((x) => {
                                  return {
                                    label: x.value + " - " + x.fullname,
                                    value: x.value,
                                  };
                                })
                        }
                        onChange={(e) => {
                          handleChange(e ? e : null, "producer");
                          setDefaultProducer(e);
                        }}
                      />
                    ) : (
                      <div className="font-medium lg:text-left">
                        {formData.producerName}
                      </div>
                    )}
                  </div>
                )}
                <div className="grid grid-cols-2">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Producer Code: <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Producer Code:
                    </div>
                  )}
                  {isEdit ? (
                    <TextInput
                      type="text"
                      value={formData.producerCode}
                      className="expandedLabel"
                      name="producerCode"
                      onChange={(e) => handleChange(e)}
                      onKeyPress={(event) => {
                        if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.producerCode}
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-2 ">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Code Level: <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Code Level:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput
                      defaultValue={codeLevelOptions.filter(
                        (x) =>
                          x.label.toUpperCase() ===
                          formData.codeLevel.toUpperCase()
                      )}
                      className="expandedLabel"
                      //defaultValue={lob}
                      name="codeLevel"
                      options={codeLevelOptions}
                      onChange={(e) => handleChange(e ? e : null, "codeLevel")}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.codeLevel}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Producer Sub Codes:
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Producer Sub Codes:
                    </div>
                  )}
                  {isEdit ? (
                    <TextInput
                      type="text"
                      name="producerSubCodes"
                      value={formData.producerSubCodes}
                      className="expandedLabel"
                      onChange={(e) => handleChange(e)}
                      onKeyPress={(event) => {
                        if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.producerSubCodes}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2 ">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Line Of Business: <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Line Of Business:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput
                      defaultValue={loboptions.filter(
                        (x) => x.label === formData.lineOfBusiness
                      )}
                      className="expandedLabel"
                      //defaultValue={lob}
                      name="lineOfBusiness"
                      options={loboptions}
                      onChange={(e) => handleChange(e ? e : null, "LOB")}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.lineOfBusiness}
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-2 ">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Producer Code Type:{" "}
                      <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Producer Code Type:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput
                      defaultValue={prodTypesOptions.filter(
                        (x) => x.value === formData.producerCodeTypeId
                      )}
                      className="font-medium"
                      name="producerCodeType"
                      options={prodTypesOptions}
                      onChange={(e) =>
                        handleChange(e ? e : null, "producerCodeType")
                      }
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {prodTypesOptions
                        ?.filter((x) => x.value === formData.producerCodeTypeId)
                        .map((x) => x.label)}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2 ">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      M&A Producer Code:
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      M&A Producer Code:
                    </div>
                  )}
                  {isEdit ? (
                    <TextInput
                      value={formData.mAproducerCodes}
                      className="expandedLabel"
                      name="mAproducerCodes"
                      onChange={(e) => handleChange(e)}
                      onKeyPress={(event) => {
                        if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.mAproducerCodes}
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-2 ">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1 ">
                      Issued To:
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Issued To:
                    </div>
                  )}
                  {isEdit ? (
                    <MultiSelectInput
                      options={
                        formData.distributionChannel === "Franchise"
                          ? employeeOpts
                              ?.filter(
                                (x) =>
                                  x.employeeId !== null &&
                                  x.employeeId !== "" &&
                                  x.isFranchise === true
                              )
                              .map((x) => {
                                return {
                                  label: x.value + " - " + x.fullname,
                                  value: x.value,
                                };
                              })
                          : employeeOpts
                              ?.filter(
                                (x) =>
                                  x.employeeId !== null &&
                                  x.employeeId !== "" &&
                                  x.isFranchise === false
                              )
                              .map((x) => {
                                return {
                                  label: x.value + " - " + x.fullname,
                                  value: x.value,
                                };
                              })
                      }
                      handleMultiSelect={(e) =>
                        handleChange(e ? e : null, "issuedTo")
                      }
                      isMulti
                      // defaultValue={selectedIssuedTo}
                      value={selectedIssuedTo}
                      className="basic-multi-select expandedLabel"
                      classNamePrefix="select"
                      // onChange={(e) => handleChange(e, "distributionChannel")}
                    />
                  ) : (
                    <>
                      <div className="font-medium lg:text-left">
                        <div data-tip={formData.issuedTo}>
                          {formData.issuedTo}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="grid grid-cols-2 ">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      MGA:
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">MGA:</div>
                  )}
                  {isEdit ? (
                    <SelectInput
                      defaultValue={mgaList.filter(
                        (x) => x.label === formData.mga
                      )}
                      className="expandedLabel"
                      //defaultValue={lob}
                      name="mga"
                      options={mgaList}
                      onChange={(e) => handleChange(e ? e : null, "mga")}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.mga}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2 ">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Carrier Program Name:
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Carrier Program Name:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput
                      className="expandedLabel"
                      //defaultValue={lob}
                      name="program"
                      options={carrierProgramOptions.filter(
                        (x) =>
                          x.carrierId === formData.masterCarrierID &&
                          x.isActive === true
                      )}
                      defaultValue={carrierProgramOptions.filter(
                        (x) =>
                          x.label === formData.program && x.isActive === true
                      )}
                      value={carrierProg}
                      onChange={(e) => {
                        handleChange(e ? e : null, "program");
                        setCarrierProg(e);
                      }}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.program}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2 ">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Can Sell:
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Can Sell:
                    </div>
                  )}
                  {isEdit ? (
                    <MultiSelectInput
                      options={allStatesOpt}
                      handleMultiSelect={(e) =>
                        handleChange(e ? e : null, "crossSale")
                      }
                      isMulti
                      value={selectedCrossSale}
                      className="basic-multi-select expandedLabel"
                      classNamePrefix="select"
                      // onChange={(e) => handleChange(e, "distributionChannel")}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.crossSale}
                    </div>
                  )}
                </div>
              </div>
              <div className="border-b border-gray-200"></div>
              <div className="grid grid-cols-3 gap-y-1 m-2">
                <div className="grid grid-cols-2">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Master Code Status:
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Master Code Status:
                    </div>
                  )}
                  {isEdit ? (
                    <div className="flex">
                      <SelectInput
                        defaultValue={
                          codeStatus.filter(
                            (x) =>
                              x.value ==
                              (formData.masterCodeStatus == "Active"
                                ? true
                                : false)
                          )[0]
                        }
                        className="expandedLabel"
                        isClearable={false}
                        name="masterCodeStatus"
                        options={codeStatus}
                        onChange={(e) => {
                          handleChange(e ? e?.value : null, "masterCodeStatus");
                        }}
                      />
                    </div>
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.masterCodeStatus}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Master Code:
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Master Code:
                    </div>
                  )}

                  {isEdit ? (
                    <SelectInput
                      defaultValue={
                        masterCodeOpts &&
                        masterCodeOpts?.filter(
                          (x) => x.label == formData.masterCode
                        )
                      }
                      className="expandedLabel"
                      isClearable={false}
                      name="masterCode"
                      options={masterCodeOpts}
                      onChange={(e) => {
                        handleChange(e ? e : null, "masterCode");
                      }}
                      isDisabled={
                        formData.masterCodeStatus === "Active" ? false : true
                      }
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.masterCode}
                    </div>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-3 gap-y-1 m-2">
                <div className="grid grid-cols-2">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Roll Up Code Status:
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Roll Up Code Status:
                    </div>
                  )}
                  {isEdit ? (
                    <div className="flex">
                      <SelectInput
                        defaultValue={
                          codeStatus.filter(
                            (x) =>
                              x.value ==
                              (formData.rollUpCodeStatus == "Active"
                                ? true
                                : false)
                          )[0]
                        }
                        className="expandedLabel"
                        isClearable={false}
                        name="rollUpCodeStatus"
                        options={codeStatus}
                        onChange={(e) => {
                          handleChange(e ? e?.value : null, "rollUpCodeStatus");
                        }}
                      />
                    </div>
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.rollUpCodeStatus}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2">
                  {isEdit ? (
                    <div className="expandedLabel text-right mr-2 mt-1">
                      Roll Up Code:
                    </div>
                  ) : (
                    <div className="expandedLabel text-right mr-2">
                      Roll Up Code:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput
                      defaultValue={
                        formData.rollUpCodeStatus === "Active"
                          ? rollUpCodeActiveOpts &&
                            rollUpCodeActiveOpts.filter(
                              (x) => x.label == formData.rollUpCode
                            )
                          : rollUpCodeOpts &&
                            rollUpCodeOpts.filter(
                              (x) => x.label == formData.rollUpCode
                            )
                      }
                      className="expandedLabel"
                      isClearable={false}
                      name="rollUpCode"
                      options={
                        formData.rollUpCodeStatus === "Active"
                          ? rollUpCodeActiveOpts?.filter(
                              (b) => b.label !== null || b.label !== ""
                            )
                          : rollUpCodeOpts?.filter(
                              (b) => b.label !== null || b.label !== ""
                            )
                      }
                      onChange={(e) => {
                        handleChange(
                          e ? e : null,
                          "rollUpId",
                          e ? e?.value : null
                        );
                      }}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.rollUpCodeStatus === "Active"
                        ? rollUpCodeActiveOpts &&
                          rollUpCodeActiveOpts.filter(
                            (x) => x.label == formData.rollUpCode
                          )[0]?.label
                        : rollUpCodeOpts &&
                          rollUpCodeOpts.filter(
                            (x) => x.label == formData.rollUpCode
                          )[0]?.label}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="h-96">
          <CustomLoader />
        </div>
      )}
    </div>
  );
};
